import CounselorClient from "@/api/CounselorClient";
import UserClient from "@/api/UserClient"
import moment from "moment"

export default class Documents {

  constructor(){
    this.documents = [];
  }

  async initialize($http, counselorId) {
    this.counselorClient = new CounselorClient($http);
    this.userClient = new UserClient($http);
    this.counselorId = counselorId;

    await this.fetch();
  }

  async setGovernmentId(file) {
    const meta = await this.userClient.getSignedUploadUrl();
    await UserClient.saveFile(meta.signed_url, file);

    const data = { government_id: meta.id };
    await this.userClient.saveCounselorProfile(data);

    // Old style doesn't give us a signed GET url. 
    // So just remake the whole thing.
    await this.fetch();
  }
  async setInsurance(file) {
    const meta = await this.userClient.getSignedUploadUrl();
    await UserClient.saveFile(meta.signed_url, file);

    const data = { malpractice_insurance: meta.id };
    await this.userClient.saveCounselorProfile(data);

    // Old style doesn't give us a signed GET url. 
    // So just remake the whole thing.
    await this.fetch();
  }
  async addLicense(type, usStateId, licenseNumber, expires, file) {
    const expirationDate = moment(expires).startOf('day');

    const response = await this.counselorClient
      .requestLicenseApproval(
        this.counselorId, 
        type, 
        licenseNumber,
        Number(usStateId), 
        expirationDate);

    await UserClient.saveFile(response.signedUploadUrl, file);
    
    this.documents.push({
      documentType: 'license',
      ...response,
      
      // We don't want the signedUploadUrl anymore. Already served its purpose.
      signedUploadUrl: undefined,
    });
  }

  async fetch() {
    this.documents = [];
    const response = await this.counselorClient.getCounselorDocuments(this.counselorId);

    if(!response)
      return;
    
    if(response.governmentId)
      this.documents.push({
        documentType: 'governmentId',
        ...response.governmentId
      })

    if(response.insurance)
      this.documents.push({
        documentType: 'insurance',
        ...response.insurance
      })
    
    if(response.originalLicense)
      this.documents.push({
        documentType: 'originalLicense',
        ...response.originalLicense
      })

    if(response.licenses)
      for(const license of response.licenses)
        this.documents.push({
          documentType: 'license',
          ...license
        })
  }
}